<template>
    <div id="supplier_institutions">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">

            <upload-subsidiary
                v-show="modalSubsidiary"
                v-if="modalSubsidiary"
                :supplier_id="rowID"
                :role_id="7"/>

            <modal-stationery
                v-show="modalStationery"
                v-if="modalStationery"
                :supplier_id="rowID"
                :role_id="role_id"
                :folder_id="7"/>

            <modal-notes
                v-show="modalNotes"
                v-if="modalNotes"
                :user_id="user_id"
                :role_id="7"
                :supplier_id="rowID"/>

            <modal-services-supplier
                v-if="modalServices"
                :role_id="7"
                :supplier_id="rowID"/>

            <!--FORM -->
            <form v-show="modalForm" id="formInst" class="animated fadeIn formInst">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="supplier.currentName">
                    <input type="hidden" name="currentEmail" v-model="supplier.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="supplier.currentUserName">
                    <input type="hidden" name="currentLogo" v-model="supplier.currentLogo">
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="supplier.logo" :src="'../storage/ambulances/'+supplier.logo" alt="">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Logotipo <br> <i class="fas fa-upload"></i> <input type="file" data-label="avatar"
                                                                                   name="logo" v-on:change="getLogo"
                                                                                   placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info logo"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                            peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usará para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <div class="row  justify-content-center">
                    <div class="col-12">
                        <cite>*Campos requeridos con linea roja.</cite>
                        <h2 class="cabeza">Datos Generales</h2>
                    </div>
                    <div class="col-12 col-md-3">
                        <p>
                            <input id="nm_prv_serv_med" v-model="supplier.nm_prv_serv_med" name="nm_prv_serv_med"
                                   type="text" class="al-inputs scr-input" placeholder="Nombre Comercial*"/>
                            <label for="nm_prv_serv_med" class="scr-supertext">Nombre Comercial*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-3">
                        <p>
                            <input id="den_per_mor" v-model="supplier.den_per_mor" name="den_per_mor" type="text"
                                   class="al-inputs scr-input" placeholder="Razón Social"/>
                            <label for="den_per_mor" class="scr-supertext">Razón Social</label>
                        </p>
                    </div>


                    <div class="col-12 col-md-3">
                        <input id="tel_emp" v-model="supplier.tel_emp" name="tel_emp" maxlength="20" type="tel"
                               class="al-inputs scr-input" placeholder="Teléfono de la Empresa" required/>
                        <label for="tel_emp" class="scr-supertext">Teléfono de la Empresa</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="correo" v-model="supplier.correo" name="correo" type="email"
                               class="al-inputs required scr-input" placeholder="E-mail*" required/>
                        <label for="correo" class="scr-supertext">E-mail*</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <select id="estado" v-model="supplier.state_id" v-on:change="selectCities($event, true)"
                                data-name-input="Selecciona un Estado" name="state_id" data-select="on"
                                class="required">
                            <option :value="0">Seleccione un Estado*</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="supplier.cities_id" name="cities_id" id="ciudad"
                                class="required" data-name-input="Selecciona una ciudad">
                            <option :value="0">Selecciona una Ciudad*</option>
                            <option v-for="city in cities" :value="city.cities_id" :key="city.cities_id">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select name="status" id="status" data-select="on" class="required" v-model="supplier.status">
                            <option :value="0">Selecciona un status</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Inactivo</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="dircomer" v-model="supplier.dir_com" name="dir_com" type="text"
                               class="al-inputs required scr-input" placeholder="Dirección Comercial"/>
                        <label for="dircomer" class="scr-supertext">Dirección Comercial</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="email" v-model="supplier.f_i_c" name="f_i_c" maxlength="10" type="date"
                               class="al-inputs scr-input" placeholder="Fecha Inicio Contrato*"/>
                        <label for="email" class="scr-supertext">Fecha Inicio Contrato*</label>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <h2 class="cabeza">Contacto Administrativo</h2>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <input id="rep_legal" v-model="supplier.rep_legal" name="rep_legal" type="text"
                                       class="al-inputs scr-input" placeholder="Nombre*"/>
                                <label for="rep_legal" class="scr-supertext">Nombre*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_email" v-model="supplier.rep_email" name="rep_email" type="text"
                                       class="al-inputs scr-input" placeholder="E-mail*"/>
                                <label for="rep_email" class="scr-supertext">E-mail*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_tel" v-model="supplier.rep_tel" name="rep_tel" type="text"
                                       class="al-inputs scr-input" placeholder="Teléfono*"/>
                                <label for="rep_tel" class="scr-supertext">Teléfono*</label>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <h2 class="cabeza">Contacto Operativo</h2>
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_nombre" v-model="supplier.rep_sec_nombre" name="rep_sec_nombre"
                                       type="text" class="al-inputs scr-input" placeholder="Nombre*"/>
                                <label for="rep_sec_nombre" class="scr-supertext">Nombre*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_email" v-model="supplier.rep_sec_email" name="rep_sec_email"
                                       type="text" class="al-inputs scr-input" placeholder="E-mail*"/>
                                <label for="rep_sec_email" class="scr-supertext">E-mail*</label>
                            </div>
                            <div class="col-12 col-md-4">
                                <input id="rep_sec_tel" v-model="supplier.rep_sec_tel" name="rep_sec_tel" type="text"
                                       class="al-inputs scr-input" placeholder="Teléfono*"/>
                                <label for="rep_sec_tel" class="scr-supertext">Teléfono*</label>
                            </div>
                        </div>
                    </div>
                </div>

                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row  justify-content-center">
                    <div class="col-12 col-md-3">
                        <input id="pass" v-model="supplier.username" name="username" type="text"
                               class="al-inputs scr-input" placeholder="Usuario"/>
                        <label for="pass" class="scr-supertext">Usuario</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="supplier.password" type="password" name="password" class="al-inputs scr-input"
                               :class="{required:!modificar}" placeholder="Password" id="password" value=""/>
                        <label for="password" class="scr-supertext">Password</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar
                        </button>
                    </div>
                </div>
            </form>

        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <!-- A virtual column -->
                            <template #cell(Proveedor)="{item}">
                                {{ item.nm_prv_serv_med }}
                            </template>
                            <template #cell(E-mail)="{item}">
                                {{ item.reluser.email }}
                            </template>
                            <template #cell(Estado)="{item}">
                        <span v-if="item.reledo">
                            {{ item.reledo.estado }}
                        </span>
                            </template>
                            <template #cell(Ciudad)="{item}">
                        <span v-if="item.relcity">
                            {{ item.relcity.ciudad }}
                        </span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('stationery')">Subir
                                            Papelería</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('subsidiary')">Agregar
                                            Sucursales</a>
                                        <a class="dropdown-item" v-if="role_id===1" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('note')">Agregar Nota</a>
                                        <a class="dropdown-item" v-if="role_id===1" href="javascript:void(0)"
                                           v-on:click="rowID=item.id; openModalsProviders('services')">Agregar
                                            Servicio</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {estadoService} from "../../Services/States.service";
import {statescitiesService} from "../../Services/Statescities.service";
import {supplierinstitutionsService} from "../../Services/SupplierInstitutions.service";
import {getFormData} from "../../Utils/getDataForm";

export default {
    name: "supplier_institutions",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isBusy: false,
            modificar: false,
            filter: null,
            supplier: {
                id: 0,
                state_id: 0,
                cities_id: 0,
                nm_prv_serv_med: '',
                den_per_mor: '',
                correo: '',
                dir_com: '',
                tel_emp: '',
                rep_legal: '',
                rep_email: '',
                rep_tel: '',
                rep_sec_nombre: '',
                rep_sec_email: '',
                rep_sec_tel: '',
                logo: '',
                status: 0,
                f_i_c: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'Proveedor', sortable: false},
                {key: 'E-mail', sortable: false},
                {key: 'Estado', sortable: false},
                {key: 'Ciudad', sortable: false},
                {key: 'Acciones', sortable: false},
            ],
            states: [],
            cities_fiscal: [],
            cities: [],
            tituloBtn: 'Agregar',
            rowID: 0,
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await supplierinstitutionsService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formInst');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formInst');
                if (this.modificar) {
                    resp = await supplierinstitutionsService.updateOne(this.supplier.id, formData, {
                        isForm: true,
                        onUploadProgress: this.onUploadProgress
                    });
                } else {
                    resp = await supplierinstitutionsService.saveOne(formData, {
                        isForm: true,
                        onUploadProgress: this.onUploadProgress
                    });
                }
                this.modificar = false;
                this.tituloBtn = 'Agregar';
                this.showModal = false;
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            this.pagination = await supplierinstitutionsService.getMany(this.params);
            this.states = await estadoService.getMany({limit: 0});
            this.isBusy = false;
        },
        async selectCities($e, kind_selected = false) {
            let state_id = this.stateId($e);
            switch (kind_selected) {
                case true:
                    this.cities = await statescitiesService.getCitiesByState(state_id);
                    break;
                default:
                    this.cities_fiscal = await statescitiesService.getCitiesByState(state_id);
                    break;
            }
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.selectCities(data.state_id, true);
                //this.selectCities(data.cities_id);
                this.tituloBtn = 'Actualizar';
                this.supplier = data;
                this.supplier.correo = data.reluser.email;
                this.supplier.ciudad = data.relcity.id;
                this.supplier.currentName = data.proveedor;
                this.supplier.currentEmail = data.reluser.email;
                this.supplier.currentUserName = data.username;
                this.supplier.username = data.reluser.username;
                this.supplier.currentLogo = data.logo;
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
        setEmpty() {
            this.supplier = {
                id: 0,
                state_id: 0,
                cities_id: 0,
                nm_prv_serv_med: '',
                den_per_mor: '',
                correo: '',
                dir_com: '',
                tel_emp: '',
                rep_legal: '',
                rep_email: '',
                rep_tel: '',
                rep_sec_nombre: '',
                rep_sec_email: '',
                rep_sec_tel: '',
                logo: '',
                status: 0,
                f_i_c: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
            }
        }
    },
    mounted() {
        //console.log('role_id', this.role_id);
        this.index();
    }
}
</script>
